export const DEFAULT_AUDIO_RECORD_LIMIT = 60
export const DEFAULT_VIDEO_RECORD_LIMIT = 300
